/*
 * File: UISearch.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Common search input component
 */
/**
 * @prop keyword string - Value stored in the parent state to be passed back to the input
 * @prop placeholder string - Input placeholder
 * @prop parentOnSubmit callable - Called to handle search submit
 * @prop parentOnChange callable - Passes the input value to the parent to store in state
 * @prop parentHandleClear callable - Called when clearing the input
 */

import React from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";

const styles = theme => ({
  searchBox: {
    position: "relative"
  },
  textField: {
    marginTop: theme.spacing(1)
  }
});

const UISearch = ({
  placeholder,
  keyword,
  classes,
  parentOnSubmit,
  parentOnChange,
  parentOnKeyPress,
  autoFocus,
  label
}) => {
  const onChange = e => {
    if (typeof parentOnChange === "function") {
      parentOnChange(e.target.value);
    }
  };

  const onSubmit = e => {
    e.preventDefault();
    e.target.keyword.blur(e);
    if (typeof parentOnSubmit === "function") {
      parentOnSubmit(e);
    }
  };

  const onKeyPress = e => {
    if (typeof parentOnKeyPress === "function") {
      parentOnKeyPress(e);
    }
  };

  return (
    <div className={classes.searchBox}>
      <form onSubmit={onSubmit} action=".">
        <TextField
          InputProps={{
            disableUnderline: true
          }}
          autoFocus={autoFocus}
          type="search"
          name="keyword"
          fullWidth={true}
          className={classes.textField}
          value={keyword}
          placeholder={placeholder}
          onChange={onChange}
          onKeyPress={onKeyPress}
          label={label}
        />
      </form>
    </div>
  );
};

UISearch.propTypes = {
  placeholder: PropTypes.string,
  keyword: PropTypes.string,
  classes: PropTypes.object.isRequired,
  parentOnSubmit: PropTypes.func,
  parentOnChange: PropTypes.func,
  parentOnKeyPress: PropTypes.func,
  autoFocus: PropTypes.bool,
  label: PropTypes.string
};

export default withStyles(styles)(UISearch);
